<ion-datetime-button [datetime]="uniqueId"></ion-datetime-button>
<ion-modal [keepContentsMounted]="true">
  <ng-template>
    <ion-datetime
      hourCycle="h23"
      [id]="uniqueId"
      [presentation]="type"
      minuteValues="0,15,30,45"
      [firstDayOfWeek]="1"
      [value]="inputDateZulu"
      [disabled]="disabled"
      (ionChange)="dateChanged($event)"
      [showDefaultButtons]="true"
      doneText="Übernehmen"
      cancelText="Abbrechen"
      [formatOptions]="{
        date: {
          weekday: 'short',
          month: 'long',
          day: '2-digit',
          year: 'numeric'
        },
        time: {
          hour: '2-digit',
          minute: '2-digit',
        },
      }"
    >
      <span slot="title">{{ title }}</span>
    </ion-datetime>
  </ng-template>
</ion-modal>
